"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconRotateCounterClockwise = _interopRequireDefault(require("./IconRotateCounterClockwise"));
var StyledIconRotateClockwise = /*#__PURE__*/(0, _styledComponents.default)(_IconRotateCounterClockwise.default).withConfig({
  displayName: "StyledIconRotateClockwise",
  componentId: "c11n-8-107-0__sc-14h2ajz-0"
})(["transform:scaleX(-1);"]);
var IconRotateClockwise = function IconRotateClockwise(props) {
  return /*#__PURE__*/_react.default.createElement(StyledIconRotateClockwise, props);
};
var _default = IconRotateClockwise;
exports.default = _default;